export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img1-98270a018229a442c83592afb3fb4b23.png";